import React, {Component} from 'react';
import './form.css';
import RatingsBar from './ratings-bar.js';
import FormInputs from './form-inputs.js';

export default class Form extends Component {

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    this.props.save();
    e.preventDefault();
  }

  render() {
    return (
      <form className="Form" onSubmit={this.handleSubmit}>
        <RatingsBar newReview={this.props.newReview} changeRating={this.props.changeRating}/>
        {
          this.props.newReview.rating &&
          <FormInputs
            newReview={this.props.newReview}
            changeComment={this.props.changeComment}
            changeName={this.props.changeName}
          />
        }
      </form>
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/reviews/new/form.js